import React from "react";

const KosmofiFooter = () => {
  return (
    <div
      className="w-full flex justify-center items-center bg-white text-black"
      style={{ height: 101, letterSpacing: 0.1 }}
    >
      © 2024 Kosmofi
    </div>
  );
};

export default KosmofiFooter;
